import * as Yup from 'yup';

export const orderDataValidationSchema = Yup.object().shape({
    deliveryAddressId: Yup.number().typeError('app.error.required').required('app.error.required'),
    invoiceAddressId: Yup.number().typeError('app.error.required').required('app.error.required'),
    deliveryDate: Yup.date().nullable().typeError('app.error.dateInvalid').min(new Date(), 'app.error.dateInPast'),
    costCentre: Yup.string().nullable(),
    functionalAssets: Yup.array()
        .of(
            Yup.mixed()
                .nullable(false)
                .test('skip-undefined', 'app.error.required', function (value) {
                    // FIXME this function get called * the actual ID value!
                    //   find a solution to use some key-value validation, instead of array
                    if (value === undefined) {
                        return true;
                    }

                    if (value === null) {
                        return false;
                    }

                    return typeof value === 'object' && value.id;
                })
        )
        .required('app.error.required'),
});
